import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { ThemeProvider } from 'styled-components'

import {
  selectCurrentVariantCohortToUse,
  selectLanguage,
} from 'root-redux/selects/common'

import { Cohort, Language } from 'root-constants/common'

import {
  COMMON_THEME,
  DARK_THEME,
  FAMYLOCATE_THEME,
  MAIN_SAFETY_THEME,
} from '../../styles/themes'

type TProps = {
  children: React.ReactNode
}

export const Theme: React.FC<TProps> = ({ children }) => {
  const cohortToUse = useSelector(selectCurrentVariantCohortToUse)
  const language = useSelector(selectLanguage)

  const currentTheme = useMemo(() => {
    switch (cohortToUse) {
      case Cohort.MAIN_SAFETY_V3:
        return MAIN_SAFETY_THEME
      case Cohort.FAMYLOCATE_V1:
        return FAMYLOCATE_THEME
      case Cohort.GOOGLE_MAIN_10:
        return DARK_THEME
      default:
        return COMMON_THEME
    }
  }, [cohortToUse])

  return (
    <ThemeProvider
      theme={{
        ...currentTheme,
        ...(language === Language.ZH && {
          locales: {
            chineseTextFontWeight: 500,
          },
        }),
      }}
    >
      {children}
    </ThemeProvider>
  )
}
